<template>
  <div class="orderDetails-view">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/personal/myorder/allOrder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="consignee" v-show="bookType === '0'">
      <p>收货人信息</p>
      <ul>
        <li v-for="(item, index) in consigneeList" :key="index">
          <div class="item-d" :class="item.isDefault ? 'active' : ''" @click="switchConsignee(item.id)">
            <p>
              {{item.name}}
              <span>
                {{item.phone}}
              </span>
            </p>
            <p>
              {{item.address + ' ' + item.detailedAddress}}
            </p>
          </div>
          <el-button type="text" icon="el-icon-delete" @click="delectArr(item)" circle></el-button>
          <el-button type="text" icon="el-icon-star-off" @click="defaultArr(item)" circle></el-button>
        </li>
      </ul>
      <!-- <el-button size="small" @click="showAddress('1')">
        修改地址
        <i class="el-icon-edit el-icon--right"></i>
      </el-button> -->
      <el-button size="small" @click="showAddress('2')">
        新增地址
        <i class="el-icon-plus el-icon--right"></i>
      </el-button>
    </div>
    <div class="list">
      <p>送货清单</p>
      <el-table
        ref="multipleTable1"
        :data="paperbookData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          label="商品信息"
          align="left">
          <template slot-scope="scope">
            <div class="goods-view">
              <div class="left">
                <img :src="scope.row.imgUrl" alt="">
              </div>
              <div class="right">
                <p class="p-describe">
                  {{scope.row.name}}
                </p>
                <p class="p-author">
                  {{scope.row.author}}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="money"
          label="单价（元）"
          align="center"
          width="300">
          <template slot-scope="scope">
            <span>
              ￥{{scope.row.money}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          align="center"
          width="300">
          <template slot-scope="scope">
            <span>
              {{scope.row.num}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="money"
          label="总价（元）"
          align="center"
          width="150">
          <template slot-scope="scope">
            <span class="rowMoney">
              ￥{{scope.row.totalPrice}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="js">
        <button @click="zf">支付</button>
      </div>
    </div>
    <!-- 操作收货地址 -->
    <el-dialog :title="addressTitle + '收货地址'" :visible.sync="dialogFormVisible" center width="500px" @close="closeDialog">
      <el-form :model="consigneeForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="收货人" prop="name">
          <el-input v-model="consigneeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input type="tel" v-model="consigneeForm.phone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="address">
          <el-cascader
            separator=" "
            :props="props"
            :options="options"
            v-model="consigneeForm.address"
            @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailedAddress">
          <el-input type="textarea" v-model="consigneeForm.detailedAddress"></el-input>
        </el-form-item>
        <el-form-item label="邮编" prop="zipCode">
          <el-input v-model="consigneeForm.zipCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="confirmClick(consigneeForm.id)">
          确认{{addressTitle}}地址
        </el-button>
        <el-button>
          返回购物车查看商品
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
export default {
  name: '',
  data () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空！'))
      } else {
        callback()
      }
    }
    var checkPhone = (rule, value, callback) => {
      var reg = /^1[34578]\d{9}$/
      if (value === '') {
        callback(new Error('手机号不能为空！'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号！'))
      } else {
        callback()
      }
    }
    var checkAddress = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('所在地区不能为空！'))
      } else {
        callback()
      }
    }
    var checkZipCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('邮编不能为空！'))
      } else {
        callback()
      }
    }
    var checkDetailedAddress = (rule, value, callback) => {
      if (!value) {
        callback(new Error('详细地址不能为空！'))
      } else {
        callback()
      }
    }
    return {
      dialogFormVisible: false,
      addressTitle: '',
      paperbookData: [],
      multipleSelection1: [],
      consigneeForm: {
        id: '',
        name: '',
        phone: '',
        address: [],
        detailedAddress: '',
        zipCode: ''
      },
      allQuery: {},
      rules: {
        name: [
          { required: true, validator: checkName, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        address: [
          { required: true, validator: checkAddress, trigger: 'change' }
        ],
        detailedAddress: [
          { required: true, validator: checkDetailedAddress, trigger: 'blur' }
        ],
        zipCode: [
          { required: true, validator: checkZipCode, trigger: 'blur' }
        ]
      },
      formLabelWidth: '120px',
      consigneeList: [],
      options: [],
      props: {
        value: 'name',
        label: 'name',
        children: 'areaModels'
      },
      bookType: ''
    }
  },
  methods: {
    switchConsignee (id) { // 切换收货人
      this.consigneeList.forEach(e => {
        e.isDefault = e.id === id
      })
    },
    showAddress (type) { // 显示地址弹出框
      this.dialogFormVisible = true
      if (type === '1') {
        this.addressTitle = '修改'
        this.consigneeList.forEach(e => {
          if (e.isDefault) {
            this.consigneeForm.id = e.id
            this.consigneeForm = {
              id: e.id,
              name: e.name,
              phone: e.phone,
              address: e.address.split(','),
              detailedAddress: e.detailedAddress,
              zipCode: e.zipCode
            }
          }
        })
      } else {
        this.addressTitle = '新增'
        this.consigneeForm = {
          id: '',
          name: '',
          phone: '',
          address: [],
          detailedAddress: '',
          zipCode: ''
        }
      }
    },
    handleChange (value) {
      console.log(value)
    },
    delectArr (row) {
      this.$confirm('是否删除该收货地址？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.deleteUserAddress(row.id)
      }).catch(() => {})
    },
    defaultArr (row) {
      this.$confirm('是否设置为默认收货地址？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.updateDefaultUserAddress(row.id)
      }).catch(() => {})
    },
    confirmClick (id) { // 收货地址提交
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.consigneeForm.id) {
            this.addUserAddress(this.consigneeForm)
          } else {
          }
        } else {
          return false
        }
      })
    },
    closeDialog () { // 收货地址弹出框 关闭时清空表单
      this.$refs['ruleForm'].resetFields()
    },
    getUserAddress (userId) { // 获取用户收货地址
      this.$get(this.$allUrl.getUserAddress + `?userId=${userId}`).then(res => {
        if (res.code === '0') {
          let list = res.data
          this.consigneeList = []
          list.forEach(e => {
            this.consigneeList.push({
              id: e.addressId,
              isDefault: e.addressStatus !== '0',
              name: e.userAddsee,
              phone: e.userPhone,
              address: e.userCities,
              detailedAddress: e.userAddress,
              zipCode: e.postcode
            })
          })
        }
      })
    },
    addUserAddress (obj) { // 新增地址
      const userId = this.$store.state.userMsg.id
      const par = `?addressee=${obj.name}&userId=${userId}&tel=${obj.phone}&address=${obj.detailedAddress}&cities=${obj.address}&postcode=${obj.zipCode}`
      this.$get(this.$allUrl.addUserAddress + par).then(res => {
        if (res.code === '0') {
          this.getUserAddress(userId)
          this.dialogFormVisible = false
        }
      })
    },
    deleteUserAddress (id) { // 删除地址
      const userId = this.$store.state.userMsg.id
      this.$get(this.$allUrl.deleteUserAddress + `?userAddressId=${id}`).then(res => {
        if (res.code === '0') {
          this.getUserAddress(userId)
        }
      })
    },
    updateDefaultUserAddress (id) {
      const userId = this.$store.state.userMsg.id
      this.$get(this.$allUrl.updateDefaultUserAddress + `?userAddressId=${id}&userId=${userId}`).then(res => {
        if (res.code === '0') {
          this.getUserAddress(userId)
        }
      })
    },
    zf () {
      if (this.bookType === '0') {
        let dz = ''
        this.consigneeList.forEach(e => {
          if (e.isDefault) {
            dz = e
          }
        })
        if (dz) {
          const userMsg = this.$store.state.userMsg
          let orderDetails = []
          this.paperbookData.forEach(e => {
            orderDetails.push({
              bookId: e.id,
              bookName: e.name,
              coverUrl: e.imgUrl,
              bookAuthors: e.author,
              price: e.money,
              num: e.num,
              totalPrice: e.totalPrice
            })
          })
          this.addOrder({
            userId: userMsg.id,
            payAmount: Number(this.allQuery.payAmount),
            bookType: this.allQuery.bookType,
            consignee: dz.name,
            address: dz.address + dz.detailedAddress,
            tel: dz.phone,
            postcode: dz.zipCode,
            orderDetails: JSON.stringify(orderDetails)
          })
        } else {
          this.$message({
            message: '请选择收货地址！',
            type: 'warning'
          })
          return false
        }
      } else {
        const userMsg = this.$store.state.userMsg
        let orderDetails = []
        this.paperbookData.forEach(e => {
          orderDetails.push({
            bookId: e.id,
            bookName: e.name,
            coverUrl: e.imgUrl,
            bookAuthors: e.author,
            price: e.money,
            num: e.num,
            totalPrice: e.totalPrice
          })
        })
        this.addOrder({
          userId: userMsg.id,
          payAmount: Number(this.allQuery.payAmount),
          bookType: this.allQuery.bookType,
          orderDetails: JSON.stringify(orderDetails)
        })
      }
    },
    addOrder (par) {
      Axios.post(this.$allUrl.addOrder, par, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          let pars = {
            userId: par.userId,
            bookType: par.bookType,
            orderDetails: par.orderDetails,
            payAmount: par.payAmount,
            orderNo: res.data
          }
          this.deleteCartList(pars)
          // this.$router.push({
          //   path: '/home/pay',
          //   query: {
          //     // payAmount: par.row.money,
          //     payAmount: '0.01',
          //     orderNo: res.data,
          //     subject: '书籍购买',
          //     body: '书籍购买'
          //   }
          // })
        } else {}
      }).catch(err => {
        console.log(err)
      })
    },
    deleteCartList (par) {
      Axios.post(this.$allUrl.deleteCartList, {
        userId: par.userId,
        bookType: par.bookType,
        orderDetails: par.orderDetails
      }, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          this.$router.push({
            path: '/home/pay',
            query: {
              payAmount: par.payAmount,
              orderNo: par.orderNo,
              subject: '书籍购买',
              body: '书籍购买'
            }
          })
          this.$root.eventHub.$emit('update_shoppingNum')
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    let area = require('@/router/area')
    this.options = area.data
    let query = this.$route.query
    const userMsg = this.$store.state.userMsg
    if (query) {
      this.allQuery = query
      this.paperbookData = JSON.parse(query.list)
      this.bookType = query.bookType
      if(userMsg && userMsg.id) {
        this.getUserAddress(userMsg.id)
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .orderDetails-view{
    padding: 30px 10px 0 10px;
    .consignee{
      margin-top: 30px;
      ul{
        list-style: none;
        padding: 0;
        margin: 0;
        li{
          margin-bottom: 20px;
          .item-d{
            p{
              padding: 5px 0;
              margin: 0;
            }
            border: 1px solid #666666;
            cursor: pointer;
            display: inline-block;
            padding: 0 10px;
          }
          .active{
            border: 1px solid red;
          }
        }
      }
    }
    .list{
      .goods-view{
        display: flex;
        .left{
          img{
            width: 60px;
            height: 80px;
          }
        }
        .right{
          flex: 1;
          padding-left: 30px;
          p{
            padding: 0;
            margin: 0;
          }
          .p-describe{
            color: #000000;
            overflow: hidden;
            word-break: break-all;
            display: -moz-box;
            -moz-box-orient:vertical;
            display: -webkit-box;
            -webkit-box-orient:vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
          }
          .p-author{
            margin-top: 10px;
            color: #666666;
          }
        }
      }
      .number-view{
        text-align: center;
        span{
          display: inline-block;
          line-height: 30px;
          text-align: center;
          vertical-align: middle;
        }
        .reduce, .plus{
          background: #DCDCDC;
          cursor: pointer;
          font-size: 20px;
          font-weight: 600;
          outline: none;
          border: 0;
          line-height: 30px;
          padding: 0;
          margin: 0;
          vertical-align: middle;
        }
        .num{
          height: 28px;
          padding: 0 10px;
          background: white;
          border: 1px solid #DCDCDC;
          margin: 0 -4px 0 -4px;
        }
      }
      .cz{
        span{
          cursor: pointer;
        }
      }
      .rowMoney{
        font-size: 16px;
        color: red;
      }
    }
  }
  .js{
    text-align: right;
    padding: 30px 50px;
    button{
      height: 40px;
      width: 100px;
      color: white;
      background: #B7151E;
      border: 0;
      border-radius: 6px;
      font-size: 18px;
      outline: none;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderDetails/orderDetails.vue